import React from 'react';
import {Layout} from 'antd';
import getSize from "../../../../utils/getSize";
import NHTable from '../../../common/NHTable';
import { message, Button, Table, Select, Input } from 'antd';
import { hasAuth, createUuid } from "../../../../utils/NHCore";
import css from "./index.css"
const {Content} = Layout;

export default class XsjfxxcxTab extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('学生缴费信息');
    }

    fmoney = (s, n) => //s:传入的float数字 ，n:希望返回小数点几位
    {
        if (s == undefined) {
            s = 0
        }
        n = n > 0 && n <= 20 ? n : 2;
        s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
        let l = s.split(".")[0].split("").reverse();
        let r = s.split(".")[1];
        let t = "";
        for (let i = 0; i < l.length; i++) {
            t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
        }
        return t.split("").reverse().join("") + "." + r;
    }

    render() {
        let columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
                cacheFixed: 'left',
                render: (text, record, index) => <div>{index + 1}</div>
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                search: 'input',
                cacheFixed: 'left',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '100px',
                search: 'input',
                cacheFixed: 'left',
                searchType:"input"
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '120px',
                search: 'input',
                searchType:"select"
            }, {
                title: '入学年份',
                dataIndex: 'RXNF',
                width: '150px',
                search: 'input',
                searchType:"select"
            }, {
                title: '身份证件号',
                dataIndex: 'SFZJH',
                width: '180px',
                search: 'input',
                searchType:"input"
            }, {
                title: '校区',
                dataIndex: 'XQMC',
                width: '180px',
                search: 'input',
                searchType:"select"
            }, {
                title: '院系',
                dataIndex: 'BMMC',
                width: '200px',
                search: 'input',
                searchType:"select"
            }, {
                title: '专业',
                dataIndex: 'ZYMC',
                width: '200px',
                search: 'input',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                dataIndex: 'BJMC',
                width: '200px',
                search: 'input',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '学生当前状态',
                dataIndex: 'XSDQZT',
                width: '150px',
                search: 'input',
                searchType:"select"
            },{
                title: '收费项目',
                dataIndex: 'SFXMMC',
                width: '150px',
                search: 'input',
                searchType:"select"
            }, {
                title: '应收金额',
                dataIndex: 'YSJE',
                width: '120px',
                search: 'input',
                render: (text) => {
                    return (
                        <div style={{textAlign: 'right'}}>{"￥" + this.fmoney(text, 2)}</div>
                    )
                },
                searchType:"input"
            }, {
                title: '实收金额',
                dataIndex: 'SSJE',
                width: '120px',
                search: 'input',
                render: (text) => {
                    return (
                        <div style={{textAlign: 'right'}}>{"￥" + this.fmoney(text, 2)}</div>
                    )
                },
                searchType:"input"
            }, {
                title: '欠费金额',
                dataIndex: 'QFJE',
                width: '120px',
                search: 'input',
                cacheFixed: 'right',
                render: (text) => {
                    return (
                        <div style={{textAlign: 'right'}}>{"￥" + this.fmoney(text, 2)}</div>
                    )
                },
                searchType:"input"
            }
        ];
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 230}}>
                <div style={{width: '100%', height: '100%',}}>
                    <NHTable ref='nhTable'
                                rowKey={record => record.PKID}
                                sign={"zhxg_yxxt_tjcx_xsjfxxcx_queryPage_scjt"}
                                columns={columns}
                                rangeFilter={true}
                                >
                        {hasAuth("zhxg_yxgl_tjcx_xsjfxxcx:export") ?
                            <Button type="primary" ghost onClick={this.handleOtpBtnClick}
                                    style={{marginLeft: 10}}>导出</Button> : undefined}
                    </NHTable>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/xsjfxxcx/scjtXsjfxxcx/xsjfxxcxTab.js